module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-docs"
  }, [_c('h4', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_vm._v("必须提供的索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1、营业执照彩色复印件")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2、法定代表人身份证复印件（非中华人民共和国公民请提交有效护照彩色复印件）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("3、授权委托书和代理人身份证复印件和非商户授权交易补偿申请表（商户办理理赔事务的代理人非为营业执照所载的法定代表人时需要提供）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("4、向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("5、索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("6、索赔人被盗账户信息截屏")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("7、被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、付款人信息、交易币种、交易金额、入账币种、入账金额）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("8、被盗账户挂失证明（信息截屏，包含挂失日期等）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("9、其他本公司或保险公司认为对向商户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('h4', [_vm._v("如有可提供的索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1、被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2、涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18e0fc9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/docs.vue
// module id = 811
// module chunks = 1